import React, { lazy } from 'react';

import { Control, Controller, FieldValues } from 'react-hook-form';
import Typography from '../../../typography/typography';
const CustomEditor = lazy(() => import('../../../editor/custom-editor'));

import "./element.scss";

export interface DynamicTextEditorProps {
	formControl: Control<FieldValues, any>;
	name: string;
	placeholder: string;
	fieldArrayName: string;
}

const DyanmicTextEditor: React.FC<DynamicTextEditorProps> = ({
	formControl,
	name,
	fieldArrayName,
	placeholder
}) => {
	return (
		<>
			<Controller
				name={`${fieldArrayName}.${name}`}
				control={formControl}
				render={({ field, fieldState }) => (
					<>
						<div className='editor-container'>
							<CustomEditor
								handleEditorReady={() => {
									if (field.value) field.onChange(field.value);
								}}
								data={field.value}
								onEditorChange={(content: string) => {
									field.onChange(content);
								}}
								config={{
									placeholder: placeholder
								}}
							/>
						</div>
						{fieldState.error?.message && (
							<Typography color='theme.error.600' type='s5'>
								{fieldState.error?.message}
							</Typography>
						)}
					</>
				)}
			/>
		</>
	);
};

export default DyanmicTextEditor;
